import { render, staticRenderFns } from "./ContinueWithFacebook.vue?vue&type=template&id=3c66dd90&"
import script from "./ContinueWithFacebook.vue?vue&type=script&lang=js&"
export * from "./ContinueWithFacebook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports